export const removedParams = (params) => {
  const result = Object.entries(params).filter(
    ([_, value]) => ![null, undefined].includes(value)
  );

  return Object.fromEntries(result);
};
